import Image from 'next/image'
import { AnimatePresence, motion } from "framer-motion";
import React, { useContext } from 'react'
import { BASE_URL } from '../../utils/FetchData';
import { isMobileContext } from '../../contexts/isMobileContext';
const OffersCard = ({ cardData, index }) => {
    const { isMobile } = useContext(isMobileContext);
    return (
        <AnimatePresence>
            <motion.div
                initial={{ opacity: "0", }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: parseFloat(index / 5 + .25), duration: .75 }}
                className='offers-card'>
                <div className='img-container'>
                    {cardData?.Img_Mobile?.data?.attributes?.url && <Image
                        src={`${BASE_URL}${isMobile ? cardData?.Img_Mobile?.data?.attributes?.url : cardData?.Img_Desktop?.data?.attributes?.url}`}
                        alt={isMobile ? cardData?.Img_Mobile?.data?.attributes?.name : cardData?.Img_Desktop?.data?.attributes?.name}
                        objectFit="cover"
                        layout='fill'
                    />}
                </div>
                <div className='card-data'>
                    <div className='sale'>{cardData?.Sale + "% Sale"}</div>
                    <div className='title light'>{cardData?.Title}</div>
                    <div className='description'>{cardData?.Description}</div>
                </div>
            </motion.div>
        </AnimatePresence>
    )
}

export default OffersCard
